export type EnvName = 'dev' | 'training'

export const getEnvName = (): EnvName | undefined => {
  const origin = globalThis.location.origin
  if (origin.includes('sample-training')) return 'training'
  if (
    origin.includes('sample-dev') ||
    origin.includes('localhost') ||
    origin.includes('127.0.0.1')
  ) {
    return 'dev'
  }
  return undefined
}

export const getEnvColor = (env: EnvName | undefined) => {
  if (env === 'dev') return 'danger'
  if (env === 'training') return 'info'
  return undefined
}

export const isDev = (): boolean => getEnvName() === 'dev'
